<template>
  <px-lateral-dialog v-model="dialog" width="545">
    <template>
      <div class="square-banner" v-if="!isPremium">
        <a href="https://proxpect.com.br/transportadora.html#premium" target="_blank">
          <v-img src="../assets/banner-v.svg"/>
        </a>
      </div>
    </template>
  </px-lateral-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters(['empresa', 'isPremium']),
  },
  methods: {
    open() {
      this.dialog = true;
    },
  },
};
</script>

<style scoped>
.square-banner {
  height: 500px;
  width: 500px;
}
</style>
